import React, { useState, useEffect } from "react";
import _ from "lodash";
import api from "../utils/api";
import {
  _getSkipByPage,
  _getCSRFTokenValue,
  _getTranslation,
  // _isFirstRender,
} from "../utils/helper";

import { Loader, Pagination } from "../atoms";
import { CardNewsletter } from "../cards";
import { Datepicker, MobileFilters } from "../forms";

const INITIAL_VALUES = {
  date: "",
  page: 1,
};

const Newsletters = (props) => {
  const [values, setValues] = useState(INITIAL_VALUES);
  const [appliedFilters, setAppliedFilters] = useState(INITIAL_VALUES);
  const [posts, setPosts] = useState([]);
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  // const isFirstLoad = _isFirstRender();

  useEffect(() => {
    // sync the values when filters are applied
    setValues(appliedFilters);

    // if (!isFirstLoad) {
    //   const debouncedFetchPosts = setTimeout(() => {
    fetchPosts();
    //   }, 500);
    //   return () => clearTimeout(debouncedFetchPosts);
    // }
  }, [appliedFilters]);

  const fetchPosts = async () => {
    setIsLoadingPosts(true);

    const POSTS_PER_PAGE = 6;
    const POSTS_SKIP = _getSkipByPage(appliedFilters.page, POSTS_PER_PAGE);

    const fields = {
      ...appliedFilters,
      skip: POSTS_SKIP,
      take: POSTS_PER_PAGE,
    };

    const csrfToken = await _getCSRFTokenValue();
    api
      .post("/newsletters", fields, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        const TOTAL_POSTS = res.data.totalNodes;
        const TOTAL_PAGES = Math.ceil(TOTAL_POSTS / POSTS_PER_PAGE);

        setIsLoadingPosts(false);
        setPosts(res?.data?.contentData);
        setTotalPages(TOTAL_PAGES);
      })
      .catch((err) => {
        setIsLoadingPosts(false);
      });
  };

  const getFilterInputs = () => {
    return (
      <React.Fragment>
        <div className="filter-item flex flex-col sm:flex-row sm:items-center gap-y-3 gap-x-4">
          <label className="hidden sm:block font-semibold">
            {_getTranslation("filter_by")}
          </label>
          <Datepicker
            mode="range"
            class="flex-1"
            value={values.date}
            placeholder={`${_getTranslation('date')}`}
            onChange={(selected) => {
              setValues({
                ...values,
                date: selected,
              });
            }}
          />
        </div>

        <div className="grid sm:grid-cols-2 gap-y-2 gap-x-4 lg:gap-x-2 sm:col-span-2 lg:col-auto sm:mt-4 md:mt-0">
          <button className="btn btn-s--pill" onClick={() => applyFilters()}>
            {_getTranslation("apply_filters")}
          </button>
          {!_.isEqual(values, INITIAL_VALUES) && (
            <button
              className="btn btn-s--pill btn-c--hollow---black"
              onClick={() => resetFilters()}
            >
              {_getTranslation("reset_filters")}
            </button>
          )}
        </div>
      </React.Fragment>
    );
  };

  const applyFilters = (pageNo = 1) => {
    setAppliedFilters({ ...values, page: pageNo });
  };

  const resetFilters = () => {
    setValues(INITIAL_VALUES);
    setAppliedFilters(INITIAL_VALUES);
  };

  const NewsletterSignUp = (props) => {
    return (
      <div
        className={`bg-ideaBlue100 text-white p-8 xl:p-12 sm:rounded-md sm:col-span-2
        ${
          props.isMobile
            ? "-mx-4 mt-8 sm:mx-0 sm:mt-0 sm:hidden flex"
            : "hidden sm:flex"
        } flex-col justify-center items-start
        `}
      >
        <h3 className="h3">{_getTranslation("subscribe_to_our_newsletter")}</h3>
        <p className="text-mobileS md:text-desktopS">
          {_getTranslation("our_funding_and_other_types_of_contributions")}.
        </p>
        <a
          href="https://us14.list-manage.com/subscribe?u=d030dc981e01b4e6eb409cf0f&id=15f9b7e50f"
          target="_blank"
          className="btn btn-s--pill btn-c--white-20"
        >
          {_getTranslation("subscribe_now")}
        </a>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="desktop-filters hidden sm:flex flex-col md:flex-row md:items-center gap-y-2 gap-x-4 sm:gap-x-8 mb-8">
        {getFilterInputs()}
      </div>

      <MobileFilters class="w-full sm:hidden mb-6">
        {getFilterInputs()}
      </MobileFilters>

      {_.isArray(posts) && posts.length > 0 ? (
        <React.Fragment>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8 mb-8 items-start">
            {posts.map((post, idx) => (
              <React.Fragment>
                {idx === 2 && <NewsletterSignUp />}
                <CardNewsletter data={post} />
              </React.Fragment>
            ))}
          </div>
          <div className="flex items-center justify-center gap-x-6 mt-8">
            <Pagination
              page={appliedFilters.page}
              totalPages={totalPages}
              setPage={(newPage) => {
                applyFilters(newPage);
              }}
            />
            {isLoadingPosts && <Loader />}
          </div>
          <NewsletterSignUp isMobile />
        </React.Fragment>
      ) : isLoadingPosts ? (
        <Loader class="mb-8" />
      ) : (
        <p>{_getTranslation("there_are_no_posts_available")}.</p>
      )}
    </React.Fragment>
  );
};

export default Newsletters;
